import { List, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { Customer } from '../../models/customer';

interface Props {
  isCustomerDataFetching: boolean;
  customersDataSource: Omit<Customer, 'groups'>[];
}

const CustomersList = ({ isCustomerDataFetching, customersDataSource }: Props): JSX.Element => {
  const { t } = useTranslation('common');

  return (
    <List
      loading={isCustomerDataFetching}
      bordered={true}
      itemLayout="vertical"
      dataSource={customersDataSource}
      renderItem={item => (
        <List.Item>
          <>
            <div>
              <Typography.Text strong>{t('label.name')}: </Typography.Text>
              {item.name}
            </div>
            <div>
              <Typography.Text strong>{t('label.email')}: </Typography.Text>
              {item.email}
            </div>
            <div>
              <Typography.Text strong>{t('label.created')}: </Typography.Text>
              {item.createdAt}
            </div>
          </>
        </List.Item>
      )}
    />
  );
};
export default CustomersList;
